<template>
<div id="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">

        <!-- <div class="modal-header">
            <slot name="header">
              <button class="modal-default-button" @click="$emit('close')">close</button>
            </slot>
          </div> -->

        <div class="modal-body">
          <slot name="body">
            N/A
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            default footer
          </slot>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Main',
  components: {

  },
  data() {
    return {};
  },
  methods: {},
  created() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import '../variables.less';

#modal {
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .75);
        display: flex;
        // align-items: flex-end;
        align-items: center;
        justify-content: center;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        width: 100%;

        @media (min-width: 335px) {
            width: calc(100% - 40px);
        }

        margin: 0 auto 20px;

        .modal-container {
            margin: 0 auto;
            overflow: scroll;
            background-color: @pfm-cart-bg;
            border-radius: 7px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all 0.3s ease;
            padding: 0 20px;

            
        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    
    &.allow-overflow {
      
      .modal-wrapper {
        .modal-container {
          overflow: visible;
        }
      }
    }
}
</style>